import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import Modal from '~/components/Modal';
import { useDeleteUserCardMutation } from '~/redux/api/userApiSlice';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

export default function CardDeleteModal({ id }: { id: number }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('app');
  const [deleteCard, { isLoading }] = useDeleteUserCardMutation();

  const handleDeleteCard = async () => {
    const response = await deleteCard(id);
    if ('data' in response && !response.error) {
      dispatch(closeModal('deleteUserCard'));
    }
  };

  return (
    <Modal
      modalKey="deleteUserCard"
      title={t('deleteCard')}
      Footer={
        <div className="flex w-full justify-center">
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            variant="secondary"
            size="medium"
            onClick={handleDeleteCard}
            className="w-full !text-red_dark"
          >
            {t('delete')}
          </Button>
          <Button
            variant="link"
            size="medium"
            onClick={() => {
              dispatch(closeModal('deleteUserCard'));
            }}
            className="w-full no-underline"
          >
            {t('cancel')}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col flex-gap-3x">
        <p className="text-title_4">{t('cancelConfirmation')}</p>
      </div>
    </Modal>
  );
}
